(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(93770);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 93770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./strings.json
var strings = __webpack_require__(99062);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/disclosure/disclosure.js + 5 modules
var disclosure = __webpack_require__(60751);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 7 modules
var transition = __webpack_require__(18857);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/marked/lib/marked.esm.js
var marked_esm = __webpack_require__(87441);
;// CONCATENATED MODULE: ./components/MarkdownComponent.tsx


let CACHED_HTML = {};
function MarkdownComponent(param) {
    let { markdown  } = param;
    if (!CACHED_HTML[markdown]) {
        CACHED_HTML[markdown] = marked_esm/* marked.parse */.TU.parse(markdown).replace(/<a href="/g, '<a target="_blank" href="');
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        dangerouslySetInnerHTML: {
            __html: CACHED_HTML[markdown]
        }
    });
}

;// CONCATENATED MODULE: ./components/FAQ.tsx





function FAQ() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-black py-[64px] md:py-[100px]",
        id: "faq",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "px-10 max-w-[745px] m-auto",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "space-y-[24px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-title text-purple",
                            children: "Frequently Asked Questions"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "divide-y divide-purple-border",
                        children: strings/* faq.map */.sb.map((faq)=>{
                            const { question , answerMarkdown  } = faq;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure */.p, {
                                as: "div",
                                className: "py-[24px] space-y-[8px]",
                                children: (param)=>/*#__PURE__*/ {
                                    let { open  } = param;
                                    return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-lg",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(disclosure/* Disclosure.Button */.p.Button, {
                                                    className: "text-left w-full text-gray-400",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: open ? "/contract.svg" : "/expand.svg",
                                                            className: classnames_default()("h-6 w-6 float-right"),
                                                            "aria-hidden": "true",
                                                            width: 30,
                                                            height: 30
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-teal-light font-[700]",
                                                            children: question
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                                                enter: "transition duration-100 ease-out",
                                                enterFrom: "transform scale-95 opacity-0",
                                                enterTo: "transform scale-100 opacity-100",
                                                leave: "transition duration-75 ease-out",
                                                leaveFrom: "transform scale-100 opacity-100",
                                                leaveTo: "transform scale-95 opacity-0",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure.Panel */.p.Panel, {
                                                    as: "dd",
                                                    className: "mt-2 pr-12",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-white font-[500]",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownComponent, {
                                                            markdown: answerMarkdown
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    });
                                }
                            }, question);
                        })
                    })
                ]
            })
        })
    });
}
const QUESTIONS__TODO_MOVE_TO_STRINGS_FILE = [
    {
        question: "WTF IS THIS? COCKPUNCH? IS THIS A REAL THING?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            children: [
                "You bet your ass this is a real thing.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "The Legend of COCKPUNCH is the tale of a fantastical world, a place where few things are what they seem. Finally, a fictional realm named and built for our chaotic times! It’s the first world-building fiction attempt by Tim Ferriss. That’s me.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "This is my first big public-facing project since my last book, Tribe of Mentors, was published in 2017. This is also the first Emergent Long Fiction (ELF) project of its kind.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "I started buying BTC in 2012–2013, began collecting NFTs in early 2021, and launched my first NFT (which was also my first fiction work) earlier this year. However, that was all just a warm-up for the main event… C\xd8CKPUNCH\xae!",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "Believe it or not, I’ve been thinking about and planning this experiment for the better part of a year. Time flies when you’re having fun. The eight great houses are established, the initial legends and mythologies are complete, there are dozens (perhaps hundreds) of secrets waiting to be discovered, and… those are just the initial conditions. The Legend of COCKPUNCH is also a Trojan Horse for quite a lot that will become clearer over time. I have some good ideas of how I can shape things, and where I can direct things, but the vast majority of this universe will unfurl as it gathers steam.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "The whole point is to embrace fun and put irreverence at the core of things. So don’t take it too seriously. I’m fucking serious.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "For more on the genesis story of COCKPUNCH, please listen to this interview I did with Kevin Rose."
            ]
        })
    },
    {
        question: "WHO IS BEHIND THIS LUNACY?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            children: [
                "Since all bios deserve the gravitas of third person, especially when associated with a high-brow brand like COCKPUNCH, here goes…",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "Tim Ferriss is the author of five #1 New York Times and Wall Street Journal bestsellers, including The 4-Hour Workweek and Tools of Titans. The Observer and other media have called Tim “the Oprah of audio” due to the influence of The Tim Ferriss Show podcast, which has now exceeded 900 million downloads, 600+ guests, and was featured as “Best Of” on Apple Podcasts three years in a row. Tim is also an early-stage technology investor/advisor (Uber, Facebook, Shopify, Duolingo, and 50+ others) and is founder of the Saisei Foundation, a nonprofit foundation focused on cutting-edge scientific research."
            ]
        })
    },
    {
        question: "HAVE YOU GONE OFF OF YOUR MEDS? HAVE YOU JOINED THE DARK SIDE? WHY WOULD YOU DO THIS WITH YOUR CAREER (SUCH AS IT IS)?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            children: [
                "I’ve long wanted to do a big experiment with fiction and art, resurrecting those old passions. I just couldn’t find the right vehicle. The conventional options just didn’t click. Then, in early 2021, the author Steven Pressfield said the following to me:",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "[Going big] doesn’t mean it necessarily has to be 800 pages long, but just a big idea. An idea that’s kind of a scary idea, that you say to yourself, “When I show this to people, they’re going to look at me and go, ‘What happened to you, Tim? Are you okay?'” That’s what I mean by big.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "Shortly thereafter, I began dreaming bigger, dreaming stranger, and allowing myself to veer into the bizarre. Allowing myself to grab a few glasses of wine at night, sketch out the truly bat-shit crazy ideas, and go fully off-menu. Ultimately, I landed on what I’m doing now, because making COCKPUNCH allows me to:",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "a) Do a deep dive on a new set of technologies,",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "b) Connect and collaborate with a bunch of gifted people in the space (Kevin Rose, Brenden Mulligan, Cozomo de’ Medici, and many others),",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "c) Create a tiny team and deadlines to keep myself motivated and accountable,",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "d) Do some wild experiments that would be impossible with traditional book publishing and other arenas where I have a lot of experience.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "e) Raise money for the non-profit Saisei Foundation, which has supported a lot of firsts in mental health therapeutics (for PTSD, treatment-resistant depression, end-of-life anxiety, etc.), psychedelic science, etc. I wouldn’t be here today if it weren’t for the types of projects that Saisei supports."
            ]
        })
    },
    {
        question: "HOW WILL PRIMARY SALE PROCEEDS BE USED?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            children: [
                "100% of proceeds from the primary sale will go to The Saisei Foundation.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "The Saisei Foundation is a registered 501(c)(3) non-profit private foundation that funds cutting-edge scientific research and other initiatives related to psychedelic medicine, mental health therapeutics, life-extension technologies, ecosystem conservation, indigenous knowledge preservation, and more.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "Past grants and success stories include many firsts -- psilocybin for treatment-resistant depression, phase III clinical trials for MDMA-assisted psychotherapy for PTSD, the first dedicated psychedelic research center in the world (Imperial College London), the first dedicated psychedelic research center in United States (Johns Hopkins Medicine), the Harvard Law Project on Psychedelics Law and Regulation (POPLAR), The Ferriss – UC Berkeley Psychedelic Journalism Fellowship (overseen by Michael Pollan), and more. The above have led to study publications in leading journals (e.g., The Lancet, NEJM) and media coverage (NYT, WSJ, GQ, and dozens more) around the world.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "Funds will be used to further the above and pursue exciting new high-leverage bets in multiple fields. The Saisei Foundation was created by me to fund uncrowded bets that I think matter. Check out some of the projects here."
            ]
        })
    },
    {
        question: "WHAT ON EARTH DOES “ELF” MEAN”?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            children: [
                "I don’t view this project as a PFP project, but I couldn’t find an apt label for what I’m doing, so I coined the term Emergent Long Fiction (ELF). Emergent Long Fiction (ELF) is an approach that I’m taking to fictional world-building, wherein even I, as the writer, don’t know the outcomes. But there’s a bit more to it. Let’s take the letters in order:",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "It’s Emergent because I’m setting some of what I think of as the initial “C”s (characters, conditions, constraints, etc.) and then writing from that as a starting point. The journey and story lines are not predetermined; it emerges as lots of things coalesce and evolve.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "By analogy, it might be like going on a trip to Europe with five friends, and you decide you’re going to start in Spain and start walking east with no set schedule or list of destinations. You set some constraints: no travel by plane, for instance, and that people can be removed or added to the group, but perhaps the group can never exceed 10 people. Then… you set off and see what adventures and misadventures develop.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "I have roughly 10-12 mini-chapters done as this point to set the stage (these will be released as text online and also as a new podcast, which is no small thing for me), and then I will be watching everything that happens around the launch and initial month closely, including responses to embedded easter eggs and mysteries, and I’ll craft the world moving forward based what people are excited about, what I’m most excited to write, friends’ input, what types of real-world communities develop, and much more.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "With each of my last five non-fiction books, I generally outline the entire book, and then it’s bricklaying. That means few surprises and little excitement for me as the author. This is different. The E of ELF means that, for the first time, my readers, listeners, fans, etc. will be able to watch me build a major project in real-time.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "The LF of ELF is “long fiction.” I decided to include “long” in this acronym so that any projects simply slapping a one-pager of half-assed lore on a website couldn’t easily use the ELF label.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "I have very specific parameters in mind to make this concrete. Generally speaking, short stories that are submitted for anthologies and so on do not exceed 10,000 words. There are definitely exceptions, but this is a reasonable cut-off. If that’s the upper limit for “short,” 10,000 words becomes the lower limit for “long.”",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "So, an ELF project must have a STARTING base of more than 10,000 words. You can’t vomit out 300 words and say the other 9,700 are coming at some nebulous point in the future. So the “long fiction” sets a bar: 10,000+ words need to be polished and ready BEFORE you launch. Then you build from there.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "Last, it’s called ELF because elves are fucking rad. When I played D&D ages ago, I was always a gray elf. I still have all of my modules from childhood. There will be multiple clans of elves in the COCKPUNCH world."
            ]
        })
    },
    {
        question: "DO THESE NFTS COME WITH UTILITY, A ROADMAP, AND A DISCORD?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            children: [
                "No, sir! No, ma’am! There is no planned utility, no planned roadmap, and no planned Discord… but there might be a few surprises in store.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "As Barry Schwartz once said, “The secret to happiness is low expectations.” Please keep this in mind throughout this entire FAQ.",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "And if I’m being honest after a few drinks, I dislike the overpromising roadmaps of a lot of web3, and it gets my knickers in a twist when artists feel like they all need to become tech startups CEOs to please speculators.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "HOWEVER, there are a few things I can say:",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "1) So far, COCKPUNCH has easily been the most fun I’ve had in years. I’ve been waking up excited and going to bed laughing to myself.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "2) I will be launching a new fiction podcast dedicated to COCKPUNCH. It’s tentatively slated for one season of roughly 10 episodes. This will be my first new podcast since 20TK, and I’ll be cross-promoting it on my main podcast (The Tim Ferriss Show), promoting it across my social (totally roughly TK across platforms), and also including it in my newsletter to build momentum.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "3) The above podcast episodes will also be published in the written word on my blog, tim.blog, which for ages was (and might still be) one of the most popular blogs in the world. It is indexed *very* well after 1,000+ blog posts, and I’m confident that readers will show up."
            ]
        })
    },
    {
        question: "SHOULD I CONSIDER THIS AN INVESTMENT?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            children: [
                "No, no. Please, God, no.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "This is an art project for me, albeit a very ambitious one, and you are getting highly stylized JPGs that are part of a fictional world. That’s what you are signing up for. I will also do some promotion, be a dancing bear for a few interviews, and generally attempt to spread mirth and merriment.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "To be clear, this should not be your 401k, your next mortgage payment, or your kid’s college tuition. Ladies and gentlemen… this is called COCKPUNCH, for fuck’s sake.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "So if you’re primarily hoping to make a quick buck, please do not buy these JPGs! Cryptoland is a dangerous place. And if you’re a day trader who expects free money by yelling on the Internet when you’re unhappy, please do not participate in this project. There are plenty of other NFT projects that will promise the moon. This promises nothing but art and stories about cocks.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "ON THE OTHER HAND, if you can easily afford to lose anything you spend on such a JPG, and if you assume whatever you pay is for entertainment value only and will not have an ROI beyond entertainment (i.e., Might I get the same entertainment out of this as 1-2 trips to Disney World, a few nice “dinner and a movie” nights, or a few trips to Broadway?), then maybe, just maybe, COCKPUNCH can give you some soul-enriching “WTF?!” laughs and surprises that are worth the price of admission.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "So, JPG ticket to crazytown. You in?"
            ]
        })
    }
];

;// CONCATENATED MODULE: ./components/Footer.tsx

function Footer() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "px-[32px] py-[36px] flex flex-col md:flex-row justify-between bg-black",
        style: {
            boxShadow: "0px 1px 16px #5CDEFF"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col md:flex-row items-center space-y-[24px] md:space-y-0 md:space-x-[32px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-xs text-gray-500 font-[700] uppercase",
                        children: "\xa9 2022 Premint, Inc"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://www.premint.xyz/terms/",
                        target: "_blank",
                        rel: "nofollow noreferrer",
                        className: "text-gray-300",
                        children: "Terms"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://www.premint.xyz/terms/",
                        target: "_blank",
                        rel: "nofollow noreferrer",
                        className: "text-gray-300",
                        children: "Privacy policy"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center mt-[24px] md:mt-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "https://twitter.com/PREMINT_NFT",
                    target: "_blank",
                    rel: "nofollow noreferrer",
                    className: "m-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/twitter.svg",
                        alt: "",
                        className: "h-4 ml-4 fill-white"
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/Header.tsx + 1 modules
var Header = __webpack_require__(87883);
// EXTERNAL MODULE: ./node_modules/luxon/src/luxon.js + 23 modules
var luxon = __webpack_require__(30120);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./hooks/useLocalTimeZone.ts


function useLocalTimeZone() {
    const [timeZone, setTimeZone] = (0,react.useState)("America/Los_Angeles");
    (0,react.useEffect)(()=>{
        // Only do this on client.
        setTimeZone(luxon/* DateTime.local */.ou.local().zoneName);
    }, []);
    return timeZone;
}

// EXTERNAL MODULE: ./web3/index.ts + 10 modules
var web3 = __webpack_require__(720);
// EXTERNAL MODULE: ./node_modules/react-countdown/dist/index.es.js
var index_es = __webpack_require__(98130);
;// CONCATENATED MODULE: ./components/Countdown.tsx




function Countdown(param) {
    let { date  } = param;
    const now = (0,web3/* useNow */.mX)();
    const renderer = (0,react.useCallback)((param)=>{
        let { days , hours , minutes  } = param;
        const parts = [
            days > 0 ? "".concat(days, " day").concat(days === 1 ? "" : "s") : null,
            hours > 0 ? "".concat(hours, " hour").concat(hours === 1 ? "" : "s") : null,
            minutes > 0 ? "".concat(minutes, " minute").concat(minutes === 1 ? "" : "s") : null
        ].filter(Boolean);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: parts.length > 0 ? parts.join(", ") : "just a moment"
        });
    }, []);
    return now === web3/* BEGINNING_OF_TIME */.XP ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        children: "..."
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.ZP, {
        now: ()=>now,
        date: date.toString(),
        renderer: renderer
    });
}

// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs
var react_toastify_esm = __webpack_require__(55678);
// EXTERNAL MODULE: ./node_modules/connectkit/build/index.es.js + 202 modules
var build_index_es = __webpack_require__(26502);
;// CONCATENATED MODULE: ./components/MintButton.tsx








const BUTTON_LAYOUT = "py-[20px] text-center text-black font-[800] block w-full rounded-full uppercase";
const TEAL_COLORS = "bg-teal bg-gradient-to-r from-teal to-teal-lightest";
const DISABLED_A_CLASSES = "opacity-50 bg-opacity-50 ".concat(TEAL_COLORS, " ").concat(BUTTON_LAYOUT);
const DISABLED_CLICKABLE_A_CLASSES = "cursor-pointer ".concat(DISABLED_A_CLASSES);
const DEFAULT_A_CLASSES = "cursor-pointer ".concat(TEAL_COLORS, " ").concat(BUTTON_LAYOUT);
const MINTING_A_CLASSES = "cursor-pointer flex space-x-[10px] justify-center bg-[#00384D] ".concat(BUTTON_LAYOUT);
const SUCCESS_A_CLASSES = "bg-green ".concat(BUTTON_LAYOUT);
function MintButton() {
    const { address  } = (0,web3/* useAccountAutoconnect */.nU)();
    const { isSoldOut , isMintOver , isSuccess , isLoading , hasMintedMax , activeList , futureMintableNonPublicList , mintableAllowance  } = (0,web3/* useMinting */.mz)();
    const personalizedOpenseaUrl = address ? "https://opensea.io/".concat(address, "/").concat(web3/* OPENSEA_SLUG */.eT) : web3/* OPENSEA_URL */.xC;
    if (isSuccess) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: personalizedOpenseaUrl,
            target: "_blank",
            className: SUCCESS_A_CLASSES,
            children: "Mint Successful!"
        });
    }
    if (hasMintedMax) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: personalizedOpenseaUrl,
            target: "_blank",
            className: SUCCESS_A_CLASSES,
            children: "Your NFT has been minted"
        });
    }
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: DISABLED_A_CLASSES,
            children: "Loading ..."
        });
    }
    if (isSoldOut) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: DEFAULT_A_CLASSES,
            href: web3/* OPENSEA_URL */.xC,
            children: "Sold out. Buy on Opensea"
        });
    }
    if (isMintOver) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: DISABLED_CLICKABLE_A_CLASSES,
            href: web3/* OPENSEA_URL */.xC,
            children: "Mint has ended!"
        });
    }
    if (!address) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(build_index_es/* ConnectKitButton.Custom */.x3.Custom, {
            children: (param)=>/*#__PURE__*/ {
                let { show  } = param;
                return (0,jsx_runtime.jsx)("a", {
                    className: DEFAULT_A_CLASSES,
                    onClick: show,
                    children: "Connect Wallet"
                });
            }
        });
    }
    if (activeList && mintableAllowance) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HasAccess, {
            priceFloat: (0,web3/* etherToFloat */.eo)(mintableAllowance.unitPrice)
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoAccessYet, {
        futureMintableNonPublicList: futureMintableNonPublicList
    });
}
const NoAccessYet = (param)=>{
    let { futureMintableNonPublicList  } = param;
    const futureMintableNonPublicListDescription = futureMintableNonPublicList ? strings/* listTypes.find */.Z9.find((listType)=>futureMintableNonPublicList.name == listType.name) : null;
    if (!futureMintableNonPublicList || !futureMintableNonPublicListDescription) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "flex items-start space-x-2 bg-[#111111] p-[12px] rounded-xl mb-[24px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/icons/warning.svg",
                            alt: "warning"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "text-gray-200",
                            children: [
                                "Your wallet isn't on an allowlist, but will be able to mint during the Public period. ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "#schedule",
                                    children: "See schedule"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: DISABLED_A_CLASSES,
                    children: [
                        "Mint in",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Countdown, {
                            date: luxon/* DateTime.fromSeconds */.ou.fromSeconds(web3/* PUBLIC_LIST.startsAt */.zm.startsAt)
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "flex items-start space-x-2 bg-[#111111] p-[12px] rounded-xl mb-[24px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/icons/success.svg",
                        alt: "success"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "text-gray-200",
                        children: [
                            "Your wallet will be able to mint during the",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: futureMintableNonPublicListDescription.title
                            }),
                            " ",
                            "period. ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "#schedule",
                                children: "See schedule"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                className: DISABLED_A_CLASSES,
                children: [
                    "Mint in",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Countdown, {
                        date: luxon/* DateTime.fromSeconds */.ou.fromSeconds(futureMintableNonPublicList.startsAt)
                    })
                ]
            })
        ]
    });
};
const HasAccess = (param)=>{
    let { priceFloat  } = param;
    const { mint , isMinting  } = (0,web3/* useMinting */.mz)();
    const [hasAgreed, setHasAgreed] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "flex items-start space-x-2 bg-[#111111] p-[12px] rounded-xl mb-[24px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/icons/success.svg",
                        alt: "success"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-gray-200",
                        children: "Your wallet is ready to mint!"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-left mb-[10px] ml-[5px] pb-[24px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "checkbox",
                            name: "time",
                            className: "mr-[8px]",
                            checked: hasAgreed,
                            onChange: ()=>setHasAgreed(!hasAgreed)
                        }),
                        "I agree to the",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "http://tim.blog/cockpunch-license",
                            rel: "noopen nofollow noreferrer",
                            target: "_blank",
                            className: "underline text-gray-400 ml-[4px]",
                            children: "NFT License Agreement"
                        }),
                        ",",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "http://tim.blog/tos",
                            rel: "noopen nofollow noreferrer",
                            target: "_blank",
                            className: "underline text-gray-400 ml-[4px]",
                            children: "Terms of Service"
                        }),
                        ", and",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "http://tim.blog/privacy",
                            rel: "noopen nofollow noreferrer",
                            target: "_blank",
                            className: "underline text-gray-400 ml-[4px]",
                            children: "Privacy Policy"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex space-x-[24px] items-center",
                children: isMinting ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: MINTING_A_CLASSES,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/spinner.svg",
                            className: "animate-spin-slow",
                            alt: "Spinner"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-white",
                            children: "Your NFT is minting..."
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: DEFAULT_A_CLASSES,
                    onClick: ()=>{
                        if (!hasAgreed) {
                            (0,react_toastify_esm/* toast */.Am)("Please agree to the terms of sale in order to mint.", {
                                position: "bottom-right",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                theme: "dark",
                                type: "warning"
                            });
                        } else {
                            mint && mint();
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "flex items-center justify-center space-x-[8px] font-serif text-[40px] font-[700]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "text-black",
                            children: [
                                "Mint for",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "font-[800] text-black",
                                    children: [
                                        priceFloat,
                                        " ETH"
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Mint.tsx








function getCurrentListDescription(isSoldOut, currentList, localTimeZone) {
    if (isSoldOut) {
        return {
            title: "Mint sold out!",
            subtitle: "Thanks to everyone for minting an NFT! Missed it? Check out secondary listings on OpenSea!"
        };
    }
    if (currentList) {
        const description = strings/* listTypes.find */.Z9.find((listType)=>listType.name == currentList.name);
        const nextList = web3/* LISTS */.sY[web3/* LISTS.indexOf */.sY.indexOf(currentList) + 1];
        const nextDescription = nextList && strings/* listTypes.find */.Z9.find((listType)=>listType.name == nextList.name);
        const subtitle = nextList && nextDescription ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            children: [
                nextDescription.title,
                " will start minting in",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Countdown, {
                    date: luxon/* DateTime.fromSeconds */.ou.fromSeconds(nextList.startsAt)
                })
            ]
        }) : "";
        return {
            title: "Now minting: ".concat(description.title),
            subtitle: subtitle
        };
    }
    return {
        title: "Each NFT will be ".concat(web3/* PUBLIC_PRICE */.C7, " ETH"),
        subtitle: "Minting begins\n    ".concat(web3/* FIRST_MINT_DATE.setZone */._i.setZone(localTimeZone).toFormat("fff"), "\n    (").concat(web3/* FIRST_MINT_DATE.setZone */._i.setZone("UTC").toFormat("hh:ssa ZZZZ"), ")")
    };
}
function MintProgress() {
    const { count , isSuccess , isSoldOut , isLoading , activeList , isMintOver , hasMintedMax  } = (0,web3/* useMinting */.mz)();
    const localTimeZone = useLocalTimeZone();
    const { title , subtitle  } = getCurrentListDescription(isSoldOut, activeList, localTimeZone);
    const percent = Math.round(count / web3/* TOTAL_COUNT */.AT * 100);
    const available = web3/* TOTAL_COUNT */.AT - count;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                id: "mint"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MintButton, {}),
                    !isLoading && (isSuccess || hasMintedMax ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "bg-[#00171F] p-[24px] rounded-xl mt-[24px]",
                        children: [
                            "The reveal is currently slated for Friday, December 9th. Follow",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://twitter.com/cockpunch/",
                                target: "_blank",
                                children: "@cockpunch"
                            }),
                            " ",
                            "on Twitter for news."
                        ]
                    }) : isMintOver ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bg-[#00171F] p-[24px] rounded-xl mt-[24px] mb-[24px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-gray-200 font-[800]",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-gray-300 font-[400]",
                                children: subtitle
                            }),
                            activeList && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-full rounded-full bg-teal-darker h-[8px] mt-[24px] mb-[8px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classnames_default()(available < 1 ? "bg-green" : "bg-gradient-to-r  from-teal to-teal-lighter", "rounded-full h-[8px]"),
                                            style: {
                                                width: "".concat(percent, "%")
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-white",
                                                children: available.toLocaleString()
                                            }),
                                            " ",
                                            "out of",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-white",
                                                children: web3/* TOTAL_COUNT.toLocaleString */.AT.toLocaleString()
                                            }),
                                            " ",
                                            "supply remaining"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }))
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./web3/config.ts + 1 modules
var config = __webpack_require__(55765);
;// CONCATENATED MODULE: ./components/Hero.tsx







function Hero(props) {
    const { className  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(className, "max-w-[1200px] m-auto my-[62px] md:flex justify-between md:space-x-[80px]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/555-image.png",
                    alt: "",
                    width: 560
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-[580px] m-auto flex flex-col items-start space-y-[10px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "space-y-[16px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: strings/* name */.u2
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownComponent, {
                                markdown: strings/* descriptionMarkdown */.Q2
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MintProgress, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center mt-[24px] md:mt-0",
                        children: [
                            "Official Links:",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://twitter.com/cockpunch/",
                                target: "_blank",
                                rel: "nofollow noreferrer",
                                className: "m-auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/twitter.svg",
                                    alt: "",
                                    className: "h-5 ml-4 fill-white"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: web3/* OPENSEA_URL */.xC,
                                target: "_blank",
                                rel: "nofollow noreferrer",
                                className: "m-auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/opensea.svg",
                                    alt: "",
                                    className: "h-5 ml-4 fill-white"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://etherscan.io/address/" + config/* CONTRACT_ADDRESS */.ez + "#code",
                                target: "_blank",
                                rel: "nofollow noreferrer",
                                className: "m-auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/etherscan.svg",
                                    alt: "",
                                    className: "h-5 ml-4 fill-white"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./hooks/useClientOnly.ts

function useClientOnly() {
    const [client, setClient] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        setClient(true);
    }, []);
    return client;
}

;// CONCATENATED MODULE: ./components/Schedule.tsx









function Schedule(props) {
    const { className  } = props;
    const localTimeZone = useLocalTimeZone();
    const clientOnly = useClientOnly();
    const now = (0,web3/* useNow */.mX)();
    const SCHEDULE = web3/* LISTS.map */.sY.map((list)=>{
        const listDescription = strings/* listTypes.find */.Z9.find((listType)=>list.name == listType.name);
        var ref, ref1;
        return {
            time: luxon/* DateTime.fromSeconds */.ou.fromSeconds(list.startsAt),
            title: (ref = listDescription === null || listDescription === void 0 ? void 0 : listDescription.title) !== null && ref !== void 0 ? ref : "Unknown List",
            description: (ref1 = listDescription === null || listDescription === void 0 ? void 0 : listDescription.description) !== null && ref1 !== void 0 ? ref1 : "Unknown!"
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                id: "schedule"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()(className, "bg-gray-900 py-[120px]"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mx-auto max-w-[800px] flex flex-col space-y-[40px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-center mb-[16px]",
                                    children: clientOnly ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            "Schedule for",
                                            " ",
                                            web3/* FIRST_MINT_DATE.setZone */._i.setZone(localTimeZone).toLocaleString(luxon/* DateTime.DATE_FULL */.ou.DATE_FULL),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                style: {
                                                    fontFamily: "'Nunito Sans', sans-serif",
                                                    fontSize: "0.8em"
                                                },
                                                children: [
                                                    "(",
                                                    web3/* FIRST_MINT_DATE.setZone */._i.setZone(localTimeZone).offsetNameShort,
                                                    ")"
                                                ]
                                            })
                                        ]
                                    }) : "Schedule"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-center font-[300]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownComponent, {
                                        markdown: strings/* scheduleSubheadMarkdown */.tG
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "hidden text-center font-[300]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "https://premint.xyz/cockpunch/",
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: "Click here"
                                        }),
                                        " ",
                                        "to check which list you’re on."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "md:grid md:grid-cols-2 col-span-2 gap-[40px] ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "hidden md:block text-teal-dark uppercase font-[800]",
                                    children: [
                                        "Time",
                                        clientOnly ? " (".concat(luxon/* DateTime.fromMillis */.ou.fromMillis(now).setZone(localTimeZone).offsetNameLong, ")") : null
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "hidden md:block text-teal-dark uppercase font-[800]",
                                    children: "Mint opens for"
                                }),
                                SCHEDULE.map((item)=>{
                                    const { time , title , description  } = item;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "mb-[8px] text-xl text-gray-200 font-[700]",
                                                        children: time.setZone(localTimeZone).toFormat("h:mm a ZZZZ")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "text-sm",
                                                        children: [
                                                            "(",
                                                            time.setZone("UTC").toFormat("h:mm a ZZZZ"),
                                                            ")"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "mb-[8px] text-xl text-gray-200 font-[700]",
                                                        children: title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "mb-[40px] md:mb-0 text-gray-400",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownComponent, {
                                                            markdown: description
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }, title);
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./pages/index.tsx









const Home = ()=>{
    const margins = "px-[24px] md:px-10";
    const { query  } = (0,router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: strings/* name */.u2 + " Mint Page | Powered by PREMINT"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.ico"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "This is the official mint page for " + strings/* name */.u2 + "."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: strings/* name */.u2 + " Mint Page | Powered by PREMINT"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "https://cockpunch.premint.xyz/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "https://cockpunch.premint.xyz/meta-image.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:site_name",
                        content: "PREMINT"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: "This is the official mint page for " + strings/* name */.u2 + "."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: strings/* name */.u2 + " Mint Page | Powered by PREMINT"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: "This is the official mint page for " + strings/* name */.u2 + "."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image:src",
                        content: "https://cockpunch.premint.xyz/meta-image.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:domain",
                        content: "https://cockpunch.premint.xyz/"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, {
                        className: margins
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Schedule, {
                        className: margins
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQ, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var pages = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [957,135,774,888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);